import { ACCOUNT_ACTIVITY_ACTION_TYPES } from "../../constants/actionTypes/accountActivityActionTypes";
import { IAccountActivityEvent, IAccountActivityInitialData } from "../../modules/members/account-activity/common/types";

const OPTIONS_ALL = { value: 'ALL', text: 'All' };

type AccountActivityType = {
    activityData: IAccountActivityEvent[];
    currentFilteredData: IAccountActivityEvent[];
    initialData: IAccountActivityInitialData;
    filters: {
        category: string;
        eventType: string;
        createdByRole: string;
        dateRange: [Date | null, Date | null];
    };
}

// Initial state typed to match the Account Activity events interface
export const INITIAL_STATE: AccountActivityType = {
    activityData: [],
    currentFilteredData: [],
    initialData: {
        householdId: '',
        roleList: {},
        typeAndNames: {},
        memberHistoryPermissionMap: {
            memberAbtLogcall: false,
            memberAbtShowcomments: false,
        },
        viewTicketDetailsLink: false,
    },
    filters: {
        category: OPTIONS_ALL.value,
        eventType: OPTIONS_ALL.value,
        createdByRole: OPTIONS_ALL.value,
        dateRange: [null, null],
    },
};

interface AccountActivityAction {
    type: string;
    payload?: any;
}

// Reducer function with typed state and action
export default (state = INITIAL_STATE, action: AccountActivityAction) => {
    switch (action?.type) {
        case ACCOUNT_ACTIVITY_ACTION_TYPES.SET_APP_EVENTS_DATA: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case ACCOUNT_ACTIVITY_ACTION_TYPES.SET_INITIAL_DATA:
            return {
                ...state,
                ...action.payload,
            };
        case ACCOUNT_ACTIVITY_ACTION_TYPES.SET_FILTERS_DATA: {
            const {filter, currentFilteredData} = action.payload;
            const filters = {
                ...state.filters,
                ...filter,
            };
            return {
                ...state,
                currentFilteredData,
                filters,
            };
        }
        case ACCOUNT_ACTIVITY_ACTION_TYPES.UPDATE_EVENT_COMMENTS: {
            const {event, eventId} = action.payload;
            const {activityData, currentFilteredData} = state;
            const existingActivityDataEvent = activityData.find((item: { id: string }) => item.id === eventId);
            if (existingActivityDataEvent) {
                existingActivityDataEvent.comments = event;
                existingActivityDataEvent.isCommentFetched = true;
            }

            const existingCurrentActivityEvent = currentFilteredData.find((item: { id: string }) => item.id === eventId);
            if (existingCurrentActivityEvent) {
                existingCurrentActivityEvent.comments = event;
                existingCurrentActivityEvent.isCommentFetched = true;
            }

            return {
                ...state,
                activityData: [...activityData],
                currentFilteredData: [...currentFilteredData],
            }

        }
        default:
            return state;
    }
};
